import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getFamilyFestDashboardAnalytics, getFamilyFestResponsesAnalytics } from './familyFestAnalyticsThunk';
const initialState = {
    status: APIStatus.IDLE,
    analytics: null,
    responses: null,
    error: undefined
};
const familyFestAnalyticSlice = createSlice({
    name: 'familyFestAnalytic',
    initialState,
    reducers: {
        clearFamilyFestAnalytics: (state) => {
            state.analytics = null;
            state.responses = null;
            state.status = APIStatus.IDLE;
            state.error = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFamilyFestDashboardAnalytics.pending, (state) => {
            state.status = APIStatus.PENDING;
        })
            .addCase(getFamilyFestDashboardAnalytics.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.analytics = action.payload;
        })
            .addCase(getFamilyFestDashboardAnalytics.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.error = action.payload;
        });
        builder
            .addCase(getFamilyFestResponsesAnalytics.pending, (state) => {
            state.status = APIStatus.PENDING;
        })
            .addCase(getFamilyFestResponsesAnalytics.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.responses = action.payload;
        })
            .addCase(getFamilyFestResponsesAnalytics.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.error = action.payload;
        });
    }
});
export const { clearFamilyFestAnalytics } = familyFestAnalyticSlice.actions;
export default familyFestAnalyticSlice.reducer;
